import Badge from "./Badge.vue";
import { pluginify } from "./../../util";
export default pluginify(Badge);
export { Badge };
